import { FC } from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { BaseToggle } from '@zazume/zzm-base';

import { useI18n } from '#/hooks/useI18n';

const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.s8};
  `
);

export interface OldManualValidationToggleProps {
  register: any;
}

export const OldManualValidationToggle: FC<OldManualValidationToggleProps> = ({ register }) => {
  const { t } = useI18n();

  return (
    <Container>
      <BaseToggle
        name="billingData.manualValidation"
        ref={register}
        label={t('fiscalInformationValidator.manualValidation')}
      />
    </Container>
  );
};
